import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {
  private readonly kilobytes: number = 1024;
  private readonly megabytes: number = this.kilobytes * 1024;

  constructor(@Inject(LOCALE_ID) private localeId: string) {}

  public transform(value: number | string): string {
    const toNumber = typeof value !== 'number' && value != null ? Number(value) : (value as number);
    if (toNumber != null && !isNaN(toNumber) && toNumber >= 0) {
      let suffix: string;
      let normalized: string;
      if (toNumber < this.kilobytes) {
        suffix = 'B';
        normalized = toNumber.toString(10);
      } else if (toNumber < this.megabytes) {
        suffix = 'KB';
        normalized = this.toDecimal(toNumber / this.kilobytes);
      } else {
        suffix = 'MB';
        normalized = this.toDecimal(toNumber / this.megabytes);
      }
      return `${normalized} ${suffix}`;
    } else {
      return value as string;
    }
  }

  private toDecimal(value: number): string {
    return new DecimalPipe(this.localeId).transform(value, '1.0-2');
  }
}
